import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Theme/Common'

export const LoggedOutContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.6rem',
  flex: 1,
  marginTop: spacing.lg,
  marginLeft: spacing.md,
  marginRight: spacing.md,
})

export const MessageStyled = styled.div({
  fontFamily: font.family.primary,
  fontSize: font.size.lg.fontSize,
  fontWeight: font.weight.semibold,
  color: colors.black,
  textAlign: 'center',
  marginBottom: spacing.md,
})
